import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { TextField, Alert, Typography } from "@mui/material";

import {
  consultaDireccion,
  crearClienteDireccion,
} from "../services/clienteService";

import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";
import AcceptServiceresponse from "app/modules/shared/components/AcceptServiceresponse";
import SCSAccordion from "app/modules/common/components/Accordions/SCSAccordion";
import { StyleInputs } from "../styles/themes";
import SkeletonForm from "app/modules/common/components/Skeleton/SkeletonForm";

import SelectItemsCatalogs, {
  SelectItemsCatalogsSpecial,
} from "app/modules/common/components/Selector";

const FormInformacionUbicabilidad = ({
  idCliente,
  tipoDireccion,
  setInfoClienteGrabada,
}) => {
  const [clienteInfo, setClienteInfo] = useState({});
  const [controlExpand, setControlExpand] = useState({
    controlExpanded: true,
    controlSave: false,
  });
  const [datosEnviadosCorrectamente, setDatosEnviadosCorrectamente] =
    useState(false);

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [idDireccionAux, setIdDireccionAux] = useState(0);

  useEffect(() => {
    const getData = async () => {
      let infoDireccion;

      const contacto = JSON.parse(localStorage.getItem("contacto"));

      try {
        const informacionDireccion = await consultaDireccion(
          idCliente,
          tipoDireccion ?? "DIRDOM"
        );

        if (informacionDireccion.state) {
          infoDireccion = informacionDireccion.data;

          setIdDireccionAux(informacionDireccion.data.idDireccionCliente);
        } else {
          contacto === null
            ? (infoDireccion = {})
            : (infoDireccion = {
                callePrincipal: contacto.callePrincipalDireccionPrincipal || "",
                calleTransversal:
                  contacto.calleTransversalDireccionPrincipal || "",
                referencia: contacto.direccionPrincipal || "",
                numeroCasa: contacto.numeroDireccionPrincipal || "",
              });
        }
        setClienteInfo(infoDireccion);
      } catch (error) {
        contacto === null
          ? (infoDireccion = {})
          : (infoDireccion = {
              callePrincipal: contacto.callePrincipalDireccionPrincipal || "",
              calleTransversal:
                contacto.calleTransversalDireccionPrincipal || "",
              referencia: contacto.direccionPrincipal || "",
              numeroCasa: contacto.numeroDireccionPrincipal || "",
            });
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, []);

  if (isLoading) {
    return <SkeletonForm />;
  }

  if (idCliente <= 0) {
    return <h2>Cliente NO existe. Primero cree el Cliente.!!</h2>;
  }

  const verificarTipoDomicilio = (tipoDomicilio) => {
    if (tipoDomicilio === "DPTO") {
      return true;
    }
    return false;
  };

  const validarDepartamento = (tipoDomicilio) => {
    if (tipoDomicilio === "CASA" || "") {
      return false;
    } else {
      return true;
    }
  };

  const validarNombreEdificio = (nombreEdificio) => {
    if (
      nombreEdificio === "" ||
      !/^[a-zA-ZÑñ" "0-9]{0,2}$/.test(nombreEdificio)
    ) {
      return false;
    } else {
      return true;
    }
  };

  const configuracionDatosEnvio = async (valores) => {
    setLoading(true);

    const informacionDireccion = {
      idCliente: idCliente,
      idDireccionCliente: idDireccionAux,

      idUbicGeografica1: valores.idUbicGeografica1,
      idUbicGeografica2: valores.idUbicGeografica2,
      idUbicGeografica3: valores.idUbicGeografica3,

      callePrincipal: valores.callePrincipal.toUpperCase(),
      calleTransversal: valores.calleTransversal.toUpperCase(),
      nombreEdificio: valores.nombreEdificio.toUpperCase(),
      numeroCasa: valores.numeroCasa.toUpperCase(),
      numeroDepartamento: valores.numeroDepartamento,
      referencia: valores.referencia.toUpperCase(),
      sector: valores.sector.toUpperCase(),
      /* tiempoResidencia: valores.tiempoResidencia, */

      tipoDireccion: tipoDireccion ?? "DIRDOM",
      tipoDomicilio: valores.tipoDomicilio,
      tipoVivienda: valores.tipoVivienda,
      esActivo: true,
    };

    /* console.log("Tabla Informacion Direccion");
    console.log(informacionDireccion); */

    try {
      const respuestaClienteDireccion = await crearClienteDireccion(
        informacionDireccion
      );

      if (respuestaClienteDireccion.state) {
        setIdDireccionAux(respuestaClienteDireccion.data);

        if (setInfoClienteGrabada) {
          setInfoClienteGrabada((args) => ({
            ...args,
            ubicabilidad: true,
          }));
        }
        setDatosEnviadosCorrectamente(true);

        setTimeout(() => {
          setLoading(false);
          setDatosEnviadosCorrectamente(false);
          handleExpand();
          setControlExpand((args) => ({
            ...args,
            controlSave: true,
          }));
        }, 1000);
      } else {
        alert(`${respuestaClienteDireccion.message}`);
      }
    } catch (error) {
      alert(`${error.response.data.message}`);

      console.log(error);
    }
  };

  const handleExpand = () => {
    setControlExpand((args) => ({
      ...args,
      controlExpanded: !args.controlExpanded,
    }));
  };

  return (
    <Formik
      initialValues={{
        idUbicGeografica1: clienteInfo.idUbicGeografica1 || "",
        idUbicGeografica2: clienteInfo.idUbicGeografica2 || "",
        idUbicGeografica3: clienteInfo.idUbicGeografica3 || "",
        sector: clienteInfo.sector || "",
        referencia: clienteInfo.referencia || "",
        numeroCasa: clienteInfo.numeroCasa || "",
        nombreEdificio: clienteInfo.nombreEdificio || "",
        callePrincipal: clienteInfo.callePrincipal || "",
        calleTransversal: clienteInfo.calleTransversal || "",
        numeroDepartamento: clienteInfo.numeroDepartamento || "",
        tipoVivienda: clienteInfo.tipoVivienda || "",
        tipoDomicilio: clienteInfo.tipoDomicilio || "",
      }}
      validationSchema={Yup.object({
        idUbicGeografica1: Yup.string().required("Provincia requerida"),
        idUbicGeografica2: Yup.string().required("Cantón requerida"),
        idUbicGeografica3: Yup.string().required("Parroquia requerida"),

        callePrincipal: Yup.string()
          .max(128, "Debería tener máximo 128 caracteres")
          .min(3, "Debería tener al menos 3 caracteres")
          .required("Calle Principal requerida"),
        numeroCasa: Yup.string()
          .max(32, "Debería tener máximo 32 caracteres")
          .min(3, "Debería tener al menos 3 caracteres"),
        calleTransversal: Yup.string()
          .max(128, "Debería tener máximo 128 caracteres")
          .min(3, "Debería tener al menos 3 caracteres")
          .required("Calle Transversal requerida"),
        referencia: Yup.string()
          .max(256, "Debería tener máximo 256 caracteres")
          .min(3, "Debería tener al menos 3 caracteres"),
        sector: Yup.string()
          .max(128, "Debería tener máximo 128 caracteres")
          .min(3, "Debería tener al menos 3 caracteres"),
        tipoDomicilio: Yup.string().required("Tipo Domicilio requerido"),
      })}
      validate={async (values) => {
        const errors = {};

        if (validarDepartamento(values.tipoDomicilio)) {
          if (validarNombreEdificio(values.nombreEdificio)) {
            errors.nombreEdificio = "Deberia tener al menos 3 caracteres";
          }
        }

        if (validarDepartamento(values.tipoDomicilio)) {
          if (validarNombreEdificio(values.numeroDepartamento)) {
            errors.numeroDepartamento = "Deberia tener al menos 3 caracteres";
          }
        }

        return errors;
      }}
      onSubmit={(values) => {
        configuracionDatosEnvio(values);
      }}
    >
      {({ values, handleChange, touched, errors, handleBlur }) => (
        <Form>
          <SCSAccordion
            tituloCabecera="Información Ubicabilidad"
            controlExpand={controlExpand}
            handleExpand={handleExpand}
          >
            <Alert severity="info">
              <Typography
                sx={{
                  fontSize: "1.2rem",
                }}
              >
                Confirma o actualiza tus datos..
              </Typography>
            </Alert>

            <div className="cliente-informacion-seccion">
              <SelectItemsCatalogsSpecial
                pais="ECU"
                especial="true"
                catalogos="UG1"
                codPadre={0}
                grupo={1}
                name="idUbicGeografica1"
                labelName="Provincia"
                componentSize={{ pcWidth: 23, phoneWidth: 45 }}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
              />

              <SelectItemsCatalogsSpecial
                pais="ECU"
                especial="true"
                catalogos="UG2"
                codPadre={values.idUbicGeografica1}
                grupo={1}
                name="idUbicGeografica2"
                labelName="Canton"
                componentSize={{ pcWidth: 23, phoneWidth: 45 }}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
              />

              <SelectItemsCatalogsSpecial
                pais="ECU"
                especial="true"
                catalogos="UG3"
                codPadre={values.idUbicGeografica2}
                grupo={1}
                name="idUbicGeografica3"
                labelName="Parroquia"
                componentSize={{ pcWidth: 23, phoneWidth: 45 }}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
              />

              <TextField
                id="sector"
                name="sector"
                type="text"
                label="Sector"
                sx={StyleInputs(23, 45)}
                value={values.sector}
                onChange={handleChange}
                size="small"
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                error={touched.sector && Boolean(errors.sector)}
                helperText={touched.sector && errors.sector}
                onBlur={handleBlur}
              />
            </div>

            <div className="cliente-informacion-seccion">
              <TextField
                id="callePrincipal"
                name="callePrincipal"
                type="text"
                label="Calle Principal"
                value={values.callePrincipal}
                onChange={handleChange}
                sx={StyleInputs(40, 65)}
                size="small"
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                error={touched.callePrincipal && Boolean(errors.callePrincipal)}
                helperText={touched.callePrincipal && errors.callePrincipal}
                onBlur={handleBlur}
              />
              <TextField
                id="numeroCasa"
                name="numeroCasa"
                label="N° Casa"
                value={values.numeroCasa}
                onChange={handleChange}
                sx={StyleInputs(13, 25)}
                size="small"
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                error={touched.numeroCasa && Boolean(errors.numeroCasa)}
                helperText={touched.numeroCasa && errors.numeroCasa}
                onBlur={handleBlur}
              />

              <TextField
                id="calleTransversal"
                name="calleTransversal"
                type="text"
                label="Calle Transversal"
                sx={StyleInputs(41, 65)}
                value={values.calleTransversal}
                onChange={handleChange}
                size="small"
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                error={
                  touched.calleTransversal && Boolean(errors.calleTransversal)
                }
                helperText={touched.calleTransversal && errors.calleTransversal}
                onBlur={handleBlur}
              />
            </div>

            <div className="cliente-informacion-seccion">
              <TextField
                id="referencia"
                name="referencia"
                label="Referencia"
                value={values.referencia}
                onChange={handleChange}
                size="small"
                //sx={{ width: "98%" }}
                sx={StyleInputs(97, 95)}
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                error={touched.referencia && Boolean(errors.referencia)}
                helperText={touched.referencia && errors.referencia}
                onBlur={handleBlur}
              />
            </div>

            <div>
              <h3>Vivienda</h3>
            </div>

            <div className="cliente-informacion-seccion">
              <SelectItemsCatalogs
                pais="ECU"
                especial="false"
                catalogos="TIPODOMIC"
                grupo={1}
                name="tipoDomicilio"
                labelName="Tipo Domicilio"
                componentSize={{ pcWidth: 19, phoneWidth: 45 }}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
              />

              <SelectItemsCatalogs
                pais="ECU"
                especial="false"
                catalogos="TIPOVIV"
                grupo={1}
                name="tipoVivienda"
                labelName="Tipo Vivivenda"
                componentSize={{ pcWidth: 19, phoneWidth: 45 }}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
              />

              {verificarTipoDomicilio(values.tipoDomicilio) && (
                <>
                  <TextField
                    id="nombreEdificio"
                    name="nombreEdificio"
                    type="text"
                    label="Nombre Edificio"
                    sx={StyleInputs(22, 45)}
                    value={values.nombreEdificio}
                    onChange={handleChange}
                    size="small"
                    inputProps={{
                      style: {
                        textTransform: "uppercase",
                      },
                    }}
                    error={
                      touched.nombreEdificio && Boolean(errors.nombreEdificio)
                    }
                    helperText={touched.nombreEdificio && errors.nombreEdificio}
                    onBlur={handleBlur}
                  />
                  <TextField
                    id="numeroDepartamento"
                    name="numeroDepartamento"
                    type="text"
                    label="Departamento"
                    sx={StyleInputs(15, 45)}
                    value={values.numeroDepartamento}
                    onChange={handleChange}
                    size="small"
                    inputProps={{
                      style: {
                        textTransform: "uppercase",
                      },
                    }}
                    error={
                      touched.numeroDepartamento &&
                      Boolean(errors.numeroDepartamento)
                    }
                    helperText={
                      touched.numeroDepartamento && errors.numeroDepartamento
                    }
                    onBlur={handleBlur}
                  />
                </>
              )}
            </div>

            <div className="confirmar-estados-servicios">
              <SCSLoadingButton loading={loading} titulo="GUARDAR" />

              {datosEnviadosCorrectamente && <AcceptServiceresponse />}
            </div>
          </SCSAccordion>
        </Form>
      )}
    </Formik>
  );
};

export default FormInformacionUbicabilidad;
